var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Axios from 'axios';
import { getCookie, loggedIn } from '../utils';
import * as LocalServerToggleStore from '../stores/LocalServerToggleStore';
export var Service;
(function (Service) {
    Service["company"] = "company";
    Service["user"] = "user";
    Service["order"] = "order";
})(Service || (Service = {}));
export class Api {
    constructor() {
        /** A void promise that we wait for before making API calls to prevent 401s */
        this.authentication = new Promise(resolve => {
            this.completeAuthentication = resolve;
        });
        this.authenticate = (cookie) => {
            const { token } = getCookie(cookie);
            const headers = token ? { Authorization: `bearer ${token}` } : {};
            this.axios = Axios.create({ headers });
            if (loggedIn(cookie)) {
                this.completeAuthentication();
            }
        };
        this.authenticate();
    }
    getDataFromService(service, controller) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.authentication;
            return this.axios.get(getUrl(service, controller));
        });
    }
    getDataFromServiceById(service, controller, id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.authentication;
            return this.axios.get(`${getUrl(service, controller)}/${id}`);
        });
    }
    getDataFromServiceByIdAndType(service, controller, id, type) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.authentication;
            return this.axios.get(`${getUrl(service, controller)}/${id}/${type}`);
        });
    }
    getDataFromServiceSubsidiaries(service, controller, id, subsidiaries, flat) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.authentication;
            return this.axios.get(`https://${window.tfoEnv}${service}-service.tofindout.se/api/${controller}/${id}?subsidiaries=${subsidiaries}&flat=${flat}`);
        });
    }
    getCompanyInvoicingService(url) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.axios.get(`https://${window.tfoEnv}${url}`, {
                headers: {
                    Authorization: `bearer ${getCookie().token}`
                }
            });
        });
    }
}
export const getUrl = (service, controller) => {
    const defaultUrl = `https://${window.tfoEnv}${service}-service.tofindout.se/api/${controller}`;
    if (LocalServerToggleStore.useLocalServer) {
        return LocalServerToggleStore.getLocalhostUrl(service, defaultUrl);
    }
    return defaultUrl;
};
